import { displaySize } from "./displaySize.js";

function init() {
    displaySize();
}

export {
    init   
}